import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'signup_auth_contract.title',
  },
  subTitle: {
    id: 'signup_auth_contract.sub_title',
  },
  typeAssurance: {
    id: 'signup_auth_contract.type_assurance',
  },
  numPolice: {
    id: 'signup_auth_contract.numero_police',
  },
  dateEffet: {
    id: 'signup_auth_contract.date_echeance',
  },
  requiredField: {
    id: 'required.field',
  },
  suivant: {
    id: 'signup_auth_button.next',
  },
  precedent: {
    id: 'signup_auth_button.previous',
  },
  modalHeader: {
    id: 'info_numero_police.header',
  },
  modalContent: {
    id: 'info_numero_police.content',
  },
  close: {
    id: 'modal.close',
  },
});
